import React from "react";

function VideosIcon() {
  return (
    <span className="anticon anticon-video">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 22 16"
      >
        <path
          fill="none"
          fillRule="nonzero"
          stroke="currentColor"
          strokeWidth="1.65"
          d="M12.179.825c.745 0 1.38.271 1.91.81.534.543.8 1.199.8 1.965h0v3.8l6.294-5.131-.009 11.455-6.285-5.14V12.4c0 .766-.266 1.422-.8 1.966-.53.538-1.165.809-1.91.809h0-8.643c-.745 0-1.381-.271-1.91-.81A2.702 2.702 0 01.825 12.4h0V3.6c0-.766.267-1.422.801-1.966.529-.538 1.165-.809 1.91-.809h0z"
        ></path>
      </svg>
    </span>
  );
}

export default VideosIcon;
